<template>
  <div>
    <el-card shadow="always">
      <el-row :gutter="5">
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
          <el-page-header title @back="$router.push({ name: 'orderservices' })"
            :content="'Adicionar objetos na O.S.'"></el-page-header>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
          <CustomerList v-model="customer" v-bind:current="customer" v-on:selected="fetchCustomer" />
        </el-col>
      </el-row>
    </el-card>
    <el-form>
      <el-card shadow="always">
        <el-row :gutter="5">
          <el-card class="box-card" shadow="never">
            <div slot="header" class="clearfix">
              <span>{{ $t("prepostagem") }}</span>
            </div>
            <div>
              <el-row :gutter="10" class="prepost-filters">
                <el-col :xs="24" :sm="12" :md="10" :lg="8" :xl="6">
                  <el-date-picker v-model="range" type="daterange" align="right" unlink-panels clearable
                    range-separator="à" format="dd/MM/yyyy" start-placeholder="Inicio" end-placeholder="Fim"
                    style="width: 100%" @change="fetchPreposts"></el-date-picker>
                </el-col>
                <el-col :xs="24" :sm="12" :md="10" :lg="8" :xl="6">
                  <el-input :placeholder="$t('pesquisar')" prefix-icon="el-icon-search" v-model="filter"
                    clearable></el-input>
                </el-col>
              </el-row>
              <el-table :data="tableDataFilter" stripe size="mini" height="400" ref="tablePrepost"
                @selection-change="handleSelectionChange" :default-sort="{ prop: 'sourcezipcode', order: 'ascending' }">
                <el-table-column type="selection" width="60"></el-table-column>
                <el-table-column sortable prop="cardpost" label="Cartão"></el-table-column>
                <el-table-column sortable prop="destinyzipcode" label="Destino"></el-table-column>
                <el-table-column sortable prop="destinyname" label="Dest. Nome"></el-table-column>
                <el-table-column sortable prop="tag" :label="$t('objeto')"></el-table-column>
                <el-table-column prop="service" :label="$t('servico')">
                </el-table-column>
                <el-table-column sortable prop="pricetable" :label="$t('valor')">
                  <template slot-scope="scope">
                    {{
                      scope.row.pricetable
                      | currency("R$ ", 2, {
                        thousandsSeparator: ".",
                        decimalSeparator: ",",
                      })
                    }}
                  </template>
                </el-table-column>
                <el-table-column sortable prop="invoice" label="NF"></el-table-column>
                <el-table-column sortable prop="createdAt" :label="$t('data')">
                  <template slot-scope="scope">
                    {{ scope.row.createdAt | formatDate }}
                  </template>
                </el-table-column>
              </el-table>
              <br />
              <el-form-item style="text-align: right">
                <el-button type="warning" autofocus @click="submitForm()">SALVAR</el-button>
              </el-form-item>
            </div>
          </el-card>
        </el-row>
      </el-card>
    </el-form>
  </div>
</template>
<script>
import { PrepostService } from '@/services/customers/prepost.services';
import { OrderServicesService } from "@/services/customers/order.services.services";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import moment from "moment";
import "moment/locale/pt-br";

export default {
  name: "AddObjectsToOrderService",
  components: {
    CustomerList,
  },
  methods: {
    fetchCustomer() {
      const vm = this;
      vm.fetchPreposts();
    },

    submitForm() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);

      const data = {
        order_service_id: vm.order_service_id,
        preposts: vm.$refs.tablePrepost.selection,
        actionType: 'ADD'
      };

      OrderServicesService
        .updateObjects(data)
        .then(response => {
          vm.fetchPreposts();
          this.$message({
            type: "success",
            message: "Ordem de Serviço atualizada com sucesso!",
          });
        })
        .catch(error => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },

    fetchRecords() {
      const vm = this;
      const groupBy = vm.tableData.reduce((cnt, cur) => (cnt[cur.serviceCode] = {
        selection: 0,
        code: cur.serviceCode,
        name: cur.service
      }, cnt), {});
      vm.tableServices = [];
      for (const key in groupBy) {
        vm.tableServices.push(groupBy[key]);
      }
    },

    fetchPreposts() {
      const vm = this;
      if (!vm.customer) {
        return false;
      }
      let startedAt = null;
      let finishedAt = null;
      if (vm.range && vm.range[0] && vm.range[1]) {
        startedAt = moment(vm.range[0]).format("YYYY-MM-DD");
        finishedAt = moment(vm.range[1]).format("YYYY-MM-DD");
      }
      const loading = vm.$loading(vm.$options.loading);
      PrepostService.orderservices(vm.customer, startedAt, finishedAt)
        .then((response) => {
          vm.tableData = response.records;
          vm.fetchRecords();
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },

    handleSelectionChange(data, index) {
      const vm = this;
      const map = data.reduce(function (prev, cur) {
        prev[cur.serviceCode] = (prev[cur.serviceCode] || 0) + 1;
        return prev;
      }, {});
      for (const row of vm.tableServices) {
        row.selection = 0;
      }
      for (const key in map) {
        const service = vm.tableServices.filter((x) => x.code === key);
        if (service.length > 0) {
          service[0].selection = map[key];
        }
      }
    },
  },

  computed: {
    tableDataFilter() {
      const vm = this;
      const term = vm.filter.trim().toLowerCase();
      if (!term) {
        return vm.tableData;
      }
      return vm.tableData.filter((data) =>
        [
          data.tag,
          data.destinyname,
          data.destinyzipcode,
          data.sourcezipcode,
          data.service,
          data.cardpost,
          data.invoice,
        ].some((value) => (value || "").toString().toLowerCase().includes(term))
      );
    },
  },

  mounted() {
    const { params } = this.$route
    if (params.id) this.order_service_id = params.id;
    if (params.customer) this.customer = params.customer

    this.fetchPreposts()
  },

  data() {
    return {
      order_service_id: undefined,
      customer: undefined,
      filter: "",
      range: [new Date().setDate(new Date().getDate() - 7), new Date()],
      preposts: [],
      tableData: [],
      tableServices: [],
    }
  }
}
</script>
<style scoped>
.prepost-filters {
  margin-bottom: 10px;
}
</style>